let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h6IMw"), load("6hCrU"), load("k08Ot"), load("78EJ0")]).then(() => parcelRequire('c0sxZ'));